<template>
    <div class="md-layout">
        <label class="md-layout-item md-size-20 md-form-label top_pad">
            {{amenity.name}}
        </label>
        <div class="md-layout-item">
            <md-chips class="md-primary pulse-on-error" v-model="amenity.details.model" :md-placeholder="amenity.details.placeholder" md-check-duplicated>
                <div class="md-helper-text">{{amenity.details.help}}</div>
            </md-chips>
        </div>
    </div>
</template>
<script>
    export default {
        name: "AmenityChips",
        props: {
            amenity: null
        }
    };
</script>
<style lang="css" scoped>
    .pulse-on-error >>> .md-duplicated {
        animation-name: pulse;
        animation-duration: 0.5s;
        animation-iteration-count: infinite;
        animation-direction: alternate;
        animation-timing-function: ease-in-out
    }

    @keyframes pulse {
        0% {
            transform: scale(1.1, 1.1);
        }

        100% {
            transform: scale(0.9, 0.9);
        }
    }
</style>
